<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13xvhRZ/tc-custom/9781250147295.jpg?1720464496325" alt="This image is the cover for the book Dark Above"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dark Above
      </h1>
      <p class="bookDescription body article font2">
        <p><b> In this sequel to the critically-acclaimed novel that grabbed fans of X-Files and Stranger Things, Jeremy Finley returns with another thriller full of aliens and government cover-ups. <br/></b><br/>For most of his life, William Chance has been the living proof that his grandmother and her fellow researchers into missing people were right all along about the terror from the stars. Now, he’s avoiding the limelight and hiding out from everyone, including his family. He knows he can avoid everything, except for the nightmares: fires, storms, disease and violence – he dreams of it all.<br/><br/> When he’s suddenly exposed, he finds that the media, government operatives and renegade true believers are desperate to find him, but he has another mission. Joined by a girl with terrifying abilities, he begins a desperate journey across the United States to find the others who share his dreams to stop what could be the final days of the world.<br/><br/>Jeremy Finley’s debut <i>The Darkest Time of Night </i>was called “outstanding” in a starred review from <i>Publishers Weekly </i>and was a June 2018 SIBA Okra Selection. Now, he continues the story of Lynn and William, fifteen years later in a new fast-paced novel full of suspense and government cover-ups, perfect for thriller and supernatural fans alike.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeremy Finley
      </h2>
      
      <p class="authorDescription body article">Jeremy Finley's investigative reporting has resulted in criminal convictions, legislative hearings before the U.S. Congress, the payout of more than a million dollars to scam victims, and the discovery of missing girls. The winner of twenty regional Emmys and Edward R. Murrow awards, he is also the winner of a national Headliner award, a national Edward. R Murrow award and a two-time recipient of the IRE award (recognizing the best in investigative journalism). He is the chief investigative reporter at the NBC affiliate in Nashville, TN, where he lives with his wife and daughters. <I>The Dark Above </I>is his first novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin's Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?64f60e8b